import { useAuthUser } from "@/lib/auth-context";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { RouteSpinner } from "../RouteSpinner";

export function RequireOnboarded(): JSX.Element {
  const { isLoaded, user } = useAuthUser();
  const loc = useLocation();
  if (!isLoaded) return <RouteSpinner />;
  if (!user) return <Navigate to="/onboarding" replace state={{ from: loc }} />;
  if (user.role !== "admin" && user.onboardingCompletedAt === null) {
    return <Navigate to="/onboarding" replace state={{ from: loc }} />;
  }
  return <Outlet />;
}
